
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'tr',
        debug: false, // Set to true for development debugging
        interpolation: {
            escapeValue: false, // React already safes from XSS
        },
        backend: {
            loadPath: `/locales/{{lng}}/{{ns}}.json?v=${Date.now()}`,
        },
    });

export default i18n;
